export default {
  // Page titles and headers
  pageTitle: 'Områden som jag är nöjd med',
  subtitle: 'Välj {count} områden som du är mest nöjd med',
  goalsTitle: 'Mina mål',
  goalsSubtitle: 'Sätt dina personliga mål',
  improveTitle: 'Områden att förbättra',
  improveSubtitle: 'Välj områden du vill arbeta med',
  satisfiedWith: 'Detta är jag nöjd med',
  wantToImprove: 'Detta vill jag förbättra',
  
  // Button labels
  saveGoals: 'Spara mål',
  continueToPlan: 'Fortsätt till plan',
  backToGoals: 'Tillbaka till mål',
  selectGoals: 'Välj mål',
  clearSelection: 'Rensa val',
  
  // Loading states
  loadingValues: 'Laddar värden...',
  loadingGoals: 'Laddar mål...',
  savingChoices: 'Sparar dina val...',
  loadingOptions: 'Laddar dina alternativ...',
  savingGoals: 'Sparar mål...',
  
  // Selection messages
  maxSelections: 'Maximalt {count} val',
  selectedCount: '{count} valda',
  selectMore: 'Välj {count} till',
  tooManySelected: 'För många valda. Avmarkera några.',
  selectedAreas: 'Valda områden: {count}/{max}',
  
  // Instructions
  instructions: 'Instruktioner',
  selectInstructions: 'Klicka på områdena du vill välja',
  deselectInstructions: 'Klicka igen för att avmarkera',
  maxSelectionReached: 'Maximalt antal val uppnått',
  improveInstructions: 'Här är listan på vad du sagt att du vill förbättra.',
  improveInstructionsDetail: 'Välj MAX 3 områden som du vill förbättra.',
  
  // Categories
  physical: 'Fysiskt',
  mental: 'Mentalt',
  social: 'Socialt',
  work: 'Arbete',
  lifestyle: 'Livsstil',
  health: 'Hälsa',
  fitness: 'Fitness',
  nutrition: 'Näring',
  sleep: 'Sömn',
  stress: 'Stress',
  relationships: 'Relationer',
  workLifeBalance: 'Arbetslivsbalans',
  
  // Status messages
  goalsSaved: 'Mål sparade framgångsrikt',
  goalsUpdated: 'Mål uppdaterade framgångsrikt',
  noGoalsSelected: 'Inga mål valda',
  pleaseSelectGoals: 'Välj minst ett område',
  noImprovementsSelected: 'Du har inte valt något att förbättra.',
  
  // Error messages
  errorLoadingGoals: 'Fel vid laddning av mål',
  errorSavingGoals: 'Fel vid sparande av mål',
  tryAgainLater: 'Försök igen senare',
  
  // Plan page translations
  howToReachGoals: 'Äntligen sista steget',
  yourImportantGoals: 'Nu ska du bara bestämma dig för HUR du ska nå dina MÅL. Lugn, jag vägleder dig hela vägen. Vi tar ett MÅL i taget! Dina MÅL är alltså att förbättra:',
  goToEvaluation: 'Gå till utvärdering',
  fillAllGoals: 'Fyll i alla dina mål för att fortsätta',
  valueIncrease: 'Jag har valt att öka mitt värde från {from} till {to}.',
  writeYourPlan: 'Nu, slutligen, ska du bara med egna ord skriva ner vad du kommer att göra för att nå ditt mål:',
  writeBriefly: 'Skriv jättekort VAD du ska göra för att nå ditt mål.',
  goalAchievedBy: 'Ska klaras senast',
  date: 'Datum',
  dateRequired: 'Du måste fylla i ett datum.',
  save: 'Spara',
  
  // Help text
  helpText: 'Välj de områden som är viktigast för dig',
  tipText: 'Du kan ändra ditt val när som helst',
  moreInfo: 'Mer information om mål',
  
  // Dialog messages
  limitReached: 'Gräns',
  limitMessage: 'Du kan bara förbättra 3 åt gången. Ta bort ett befintligt val för att lägga till ett nytt.',
  incompleteSelection: 'Ofullständigt val',
  incompleteMessage: 'Du måste välja exakt 3 områden att förbättra för att fortsätta.',
  selectedGoals: 'Dina valda mål',
  selectedGoalsSubheader: 'Du har valt 3 områden att förbättra:',
  change: 'Ändra',
  continue: 'Fortsätt',
  
  // Progress
  step1: 'Steg 1: Välj nöjda områden',
  step2: 'Steg 2: Sätt förbättringsmål',
  step3: 'Steg 3: Skapa handlingsplan',
  
  // Confirmation
  confirmSelection: 'Bekräfta val',
  confirmMessage: 'Är du säker på att du vill spara dessa mål?',
  yes: 'Ja',
  no: 'Nej',
  // Plan results page translations
  summary: 'Sammanfattning',
  planComplete: 'Din livsstilsplan är nu klar!',
  yourGoals: 'Dina mål',
  goalsSummary: 'Här är en sammanfattning av din Livsstilsplan och hur du tänker nå dina MÅL:',
  willImprove: 'Jag ska förbättra',
  goalAchievedByDate: 'Målet ska uppnås {date}.',
  willDoFollowing: 'Jag ska göra följande för att klara det:',
  finallyComplete: 'Bra jobbat – vi ses nästa gång det är dags att uppdatera din livsstilsplan!',
  completeLifestylePlan: 'Avsluta denna livsstilsplan',
  loadingPlan: 'Hämtar din plan...',
  
  // Feedback modal translations
  closingQuestions: 'Avslutande frågor',
  just4Questions: 'Nu bara 4 avslutande frågor om vad du tycker om Bwell-arbetet.',
  questionsAnswered: '{answered} / {total} frågor besvarade',
  helpUsImprove: 'Hjälp oss förbättra',
  noQuestionsAvailable: 'Inga frågor tillgängliga just nu.',
  answerRegistered: 'Svar registrerat',
  pleaseAnswerAll: 'Vänligen besvara alla frågor för att fortsätta',
  sending: 'Skickar...',
  sendAnswers: 'Skicka svar',
  failedToSend: 'Det gick inte att skicka svaren. Försök igen.',
  thankYouForFeedback: 'Tack för din feedback!',
  feedbackHelpsImprove: 'Dina svar hjälper oss att förbättra Bwell.',
  failedToLoadQuestions: 'Kunde inte ladda feedbackfrågor'
};
